import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { ModificationBuilderuhgnvnxpchbi as ModificationBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModificationBuilder.mjs';
import {
  User8yb1tqk4kykg as User,
  get_entries19ryowjr3zlbs as get_entries,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_mfaEnabled1lbzuse6gxxu1 as get_mfaEnabled } from '../../../../../../crowpay-shared/com/crowpay/UserFields.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import {
  intercepted2ogpsikxxj4u0 as intercepted,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../components/nav/crowpay.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../dialogs/GenericConfirmationDialog.mjs';
import { returnIfSuspendedqak8u4r448cu as returnIfSuspended } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coroutineInternalJS.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { pushChanges1lnw8bjwewvzf as pushChanges } from '../../../utils/Draft.ext.mjs';
import { delayolwo40i9ucjz as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { FinishProoflhqad7xhem5u as FinishProof } from '../../../../../../lightning-server-shared/com/lightningkite/lightningserver/auth/proof/proofModels.mjs';
import { get_selectedApi2skzkr2pn0lot as get_selectedApi } from '../../../sdk/apiOptions.mjs';
import {
  _PhoneNumber___get_raw__impl__gc2pmp2lry17e31ba5a as _PhoneNumber___get_raw__impl__gc2pmp,
  PhoneNumber__toString_impl_7i2x3q276u0h00tg72g as PhoneNumber__toString_impl_7i2x3q,
  _EmailAddress___get_raw__impl__6ose21hsaqj8b5ou10 as _EmailAddress___get_raw__impl__6ose2,
} from '../../../../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_atEnd1cw5d2zgug26 as get_atEnd,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { activityIcon1ob72qc2woiai as activityIcon } from '../../components/iconShortcuts.mjs';
import {
  bodyBold2czwdzwknab0k as bodyBold,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
  title1nssp3ryhwuqj as title,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
} from '../../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import {
  get_textButtonybbt8y3eu5hx as get_textButton,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText33v0vmsdeuehr as specCenteredText,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  specCenteredContent3evlhhbrk2e00 as specCenteredContent,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText_0,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_Stretch_getInstancecei5ndh62f1w as Align_Stretch_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  timesx4ey3un7ihw1 as times,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_edit2tiiawv2658bs as get_edit } from '../../../icons.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  plus2opbwe063z9pg as plus,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  resize3py5p2yrjp6p7 as resize,
  Action1a4ymn5nx79hk as Action,
} from '../../../utils/utils.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { get_currentContractor2yiwyln4wfsro as get_currentContractor } from '../../../selectedContractor.mjs';
import { ViewLegalDocument2rrxowcqg42d as ViewLegalDocument } from '../common/ViewLegalDocument.mjs';
import { Emitter3oauzcbmv9irf as Emitter } from '../../../../../../reactive/com/lightningkite/reactive/core/processes.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { UserForm7kih3xavfx72 as UserForm } from '../client/UserForm.mjs';
import { withWritedlio9p0oewet as withWrite } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  Char__rangeTo_impl_tkncvp2wb70up86k2i2 as Char__rangeTo_impl_tkncvp,
  Char19o2r8palgjof as Char,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  toList3jhuyej2anx2q as toList,
  minus2znw4oicpx34e as minus,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { assert1g4x8g8kl5hay as assert } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { RestartableProcess1yhsc2b2m6aws as RestartableProcess } from '../../../utils/RestartableProcess.mjs';
import {
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
} from '../../components/space.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { get_fullName2ompl3bj5l3sh as get_fullName } from '../../../../../../crowpay-shared/com/crowpay/extensions/User.ext.shared.mjs';
import { label287uhiq3m9m4z as label2 } from '../../components/label2.mjs';
import { PhoneNumberFormat_USA_getInstance22618h2la6wkm as PhoneNumberFormat_USA_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { isDigit3mimrri4wkzop as isDigit } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { takeLast2r8kr8e6g6hi7 as takeLast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../../theming/sections.mjs';
import { isNotBlank2uco4vj45ytp1 as isNotBlank } from '../../../../../../crowpay-shared/com/crowpay/extensions/Address.ext.mjs';
import { Switchrdgqp2jwylc6 as Switch } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Switch.commonHtml.mjs';
import { NoHoverSemantic_getInstance1icuasw0irscx as NoHoverSemantic_getInstance } from '../../theming/appTheme.mjs';
import { render38qn7o0b2bza2 as render } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { AgreementData1bovrwm0h7gbm as AgreementData } from '../../../utils/AgreementData.mjs';
import { get_waitForNotNull1jl9mx6el51tq as get_waitForNotNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { exportCrowPayLegalDocument31qdjr0k7gqoi as exportCrowPayLegalDocument } from '../../dialogs/emailDocumentDialog.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$withWrite, enabled, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = session.afw_1.geo(session.gfv_1);
  // Inline function 'com.lightningkite.lightningdb.modification' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (ModificationBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$1);
  this_1.c44(get_mfaEnabled(it), enabled);
  var tmp$ret$6 = this_1.m1r();
  var tmp_2 = tmp_0.nen(tmp$ret$6, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.oj0_1.fj0_1.iah(true, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, confirmed, $completion) {
  if (confirmed) {
    var tmp = $this.pj0_1.hj0_1.iah(false, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  // Inline function 'kotlin.coroutines.resume' call
  var this_0 = $this.qj0_1;
  // Inline function 'kotlin.Companion.success' call
  var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
  this_0.rc(tmp$ret$0);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, confirmed, $completion) {
  if (confirmed) {
    var tmp = $this.rj0_1.hj0_1.iah(true, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  // Inline function 'kotlin.coroutines.resume' call
  var this_0 = $this.sj0_1;
  // Inline function 'kotlin.Companion.success' call
  var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
  this_0.rc(tmp$ret$0);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.tj0_1.hj0_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
    cancellable.ta5();
    var tmp_0 = get_dialogStack();
    tmp_0.zgd(new (GenericConfirmationDialog())('Disable MFA?', 'Disabling MFA will remove the requirement to provide a passcode sent to your phone number through SMS along side the email passcode. This is not recommended as it is less secure.', VOID, 'Disable MFA', 'Nevermind', VOID, VOID, VOID, VOID, VOID, UserProfile$render$lambda$slambda$slambda_0($this.tj0_1, cancellable)));
    var tmp$ret$2 = cancellable.ua5();
    var tmp_1 = returnIfSuspended(tmp$ret$2, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  } else {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    var cancellable_0 = new (CancellableContinuationImpl())(intercepted($completion), 1);
    cancellable_0.ta5();
    var tmp_2 = get_dialogStack();
    tmp_2.zgd(new (GenericConfirmationDialog())('Enable MFA?', 'Enabling MFA will require you to provide a passcode sent to your phone number through SMS along side the email passcode. Message and data rates may apply.', VOID, 'Enable MFA', 'Nevermind', VOID, VOID, VOID, VOID, VOID, UserProfile$render$lambda$slambda$slambda_2($this.tj0_1, cancellable_0)));
    var tmp$ret$6 = cancellable_0.ua5();
    var tmp_3 = returnIfSuspended(tmp$ret$6, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
var UserProfile$render$lambda$slambda$slambdaClass;
function UserProfile$render$lambda$slambda$slambda() {
  if (UserProfile$render$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $cont) {
        this.pj0_1 = this$0;
        this.qj0_1 = $cont;
      }
      egk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    UserProfile$render$lambda$slambda$slambdaClass = $;
  }
  return UserProfile$render$lambda$slambda$slambdaClass;
}
function UserProfile$render$lambda$slambda$slambda_0(this$0, $cont) {
  var i = new (UserProfile$render$lambda$slambda$slambda())(this$0, $cont);
  var l = (confirmed, $completion) => i.egk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
var UserProfile$render$lambda$slambda$slambdaClass_0;
function UserProfile$render$lambda$slambda$slambda_1() {
  if (UserProfile$render$lambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $cont) {
        this.rj0_1 = this$0;
        this.sj0_1 = $cont;
      }
      egk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    UserProfile$render$lambda$slambda$slambdaClass_0 = $;
  }
  return UserProfile$render$lambda$slambda$slambdaClass_0;
}
function UserProfile$render$lambda$slambda$slambda_2(this$0, $cont) {
  var i = new (UserProfile$render$lambda$slambda$slambda_1())(this$0, $cont);
  var l = (confirmed, $completion) => i.egk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = $this.uj0_1.fj0_1.iah(false, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.uj0_1.gj0_1.vj0_1.nai();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = pushChanges($this.zj0_1.gj0_1.vj0_1, tmp$ret$0.afw_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = $this.zj0_1.fj0_1.iah(false, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $this$RestartableProcess, $completion) {
  var count = 10;
  while (count > 0) {
    var _unary__edvuaz = count;
    count = _unary__edvuaz - 1 | 0;
    $this$RestartableProcess.gaq(_unary__edvuaz);
    if (count < 7) {
      $this.aj1_1.lj0_1.oam(false);
    }
    var tmp = delay(1000n, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  $this$RestartableProcess.gaq(null);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, $this$Action, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_issues($this.bj1_1.kj0_1);
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!tmp.i1())
    return Unit_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.bj1_1.ij0_1;
  var tmp_0 = await_1(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp0_elvis_lhs = tmp_0;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException().o4('No proof token');
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var token = tmp_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = get_session();
  var tmp_2 = await_0(this_2, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var session = tmp_2;
  var tmp_3 = session.vfw().yfg_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.bj1_1.kj0_1;
  var tmp_4 = await_1(this_3, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp$ret$4 = tmp_4;
  var tmp_5 = tmp_3.qei(new (FinishProof())(token, tmp$ret$4), $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var proof = tmp_5;
  var tmp_6 = session.vfw().cfh_1.afs(proof, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_selectedApi();
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.dfx().yfg_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.cj1_1.ej0_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = tmp_0.pei(_PhoneNumber___get_raw__impl__gc2pmp(tmp$ret$1.f88_1), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  $this.cj1_1.ij0_1.oam(tmp_2);
  $this.cj1_1.lj0_1.oam(true);
  $this.cj1_1.mj0_1.zg5();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.dj1_1.ij0_1;
  var tmp_0 = await_1(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var t = tmp_0;
  if (t == null) {
    var tmp_1 = session.vfw().yfg_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $this.dj1_1.ej0_1;
    var tmp_2 = await_0(this_2, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp$ret$2 = tmp_2;
    var tmp_3 = tmp_1.pei(_PhoneNumber___get_raw__impl__gc2pmp(tmp$ret$2.f88_1), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    $this.dj1_1.ij0_1.oam(tmp_3);
    $this.dj1_1.mj0_1.zg5();
  } else {
    $this.dj1_1.nj0_1.zbe($this.ej1_1);
  }
  return Unit_instance;
}
function phoneNumberVerification($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  var tmp = get_compact(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(false);
  view_0.lbb(get_centered(view_0), activityIcon(view_0));
  view_0.lbb(get_centered(view_0), bodyBold(view_0, 'Verify Phone Number'));
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl_4(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_4(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    var tmp$ret$4 = $this$reactiveScope.daj($this.ij0_1) == null ? 'Your phone number needs to be verified before you can receive SMS notifications. Message and data rates may apply.' : 'Please enter the passcode texted to ' + PhoneNumber__toString_impl_7i2x3q($this$reactiveScope.daj($this.ej0_1).f88_1) + ' below to verify your phone number.';
    this_0.set(tmp$ret$4);
    return Unit_instance;
  });
  view.hbb(p_1, view_1);
  var tmp_2 = shownWhen(view, VOID, ($this$shownWhen) => !($this$shownWhen.daj($this.ij0_1) == null));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_2 = view.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.gbb(p_2, view_2);
  view_2.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_3 = view_2.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextInput())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
  var value = 'Passcode';
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  view_3.vb5_1.bb4_1.kb7_1.placeholder = value;
  view_3.zah(view_3.icn_1, $this.kj0_1);
  view_3.obg($this.nj0_1);
  view_2.hbb(p_3, view_3);
  view_2.lbb(tmp_3, view_3);
  var tmp_4 = view_2.kbb(get_centered(view_2), get_textButton(view_2));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Button())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.gbb(p_4, view_4);
  var tmp_5 = KMutableProperty0();
  var tmp_6 = Button$_get_enabled_$ref_61t7nx_1(view_4);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('enabled', 0, tmp_5, tmp_6, Button$_set_enabled_$ref_o8kynz_1(view_4));
  reactiveScope(view_4, ($this$reactiveScope) => {
    var tmp$ret$17 = $this$reactiveScope.daj($this.mj0_1) == null;
    this_1.set(tmp$ret$17);
    return Unit_instance;
  });
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.gbb(p_5, view_5);
  view_5.lba(view_5.qb6_1.abf(BodySemantic_getInstance()));
  var tmp_7 = KMutableProperty0();
  var tmp_8 = TextView$_get_content_$ref_4pzcwl_5(view_5);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_5(view_5));
  reactiveScope(view_5, ($this$reactiveScope) => {
    var tmp;
    if ($this$reactiveScope.daj($this.lj0_1)) {
      tmp = 'Text sent!';
    } else {
      var tmp0_safe_receiver = $this$reactiveScope.daj($this.mj0_1);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = 'Can resend code in ' + tmp0_safe_receiver;
      }
      var tmp1_elvis_lhs = tmp_0;
      tmp = tmp1_elvis_lhs == null ? 'Send me a new code' : tmp1_elvis_lhs;
    }
    var tmp$ret$21 = tmp;
    this_2.set(tmp$ret$21);
    return Unit_instance;
  });
  view_4.hbb(p_5, view_5);
  onClick(view_4, 'Send Code', VOID, UserProfile$phoneNumberVerification$slambda_0($this));
  view_2.hbb(p_4, view_4);
  view_2.lbb(tmp_4, view_4);
  view.hbb(p_2, view_2);
  view.lbb(tmp_2, view_2);
  var tmp_9 = view.kbb(get_atEnd(view), get_primaryButton(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (Button())(view.pc());
  var tmp0_elvis_lhs_6 = view.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
  view.gbb(p_6, view_6);
  var tmp_10 = KMutableProperty0();
  var tmp_11 = Button$_get_enabled_$ref_61t7nx_2(view_6);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('enabled', 0, tmp_10, tmp_11, Button$_set_enabled_$ref_o8kynz_2(view_6));
  reactiveScope(view_6, ($this$reactiveScope) => {
    var tmp$ret$35 = $this$reactiveScope.daj($this.ij0_1) == null || $this$reactiveScope.daj(get_issues($this.kj0_1)).i1();
    this_3.set(tmp$ret$35);
    return Unit_instance;
  });
  specCenteredText(view_6, ($this$specCenteredText) => $this$specCenteredText.daj($this.ij0_1) == null ? 'Text Verification Code' : 'Submit');
  onClick(view_6, 'Begin or Submit', VOID, UserProfile$phoneNumberVerification$slambda_2($this, view_6));
  view.hbb(p_6, view_6);
  view.lbb(tmp_9, view_6);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function UserProfile$cached$lambda($this$remember) {
  var session = $this$remember.daj(get_session());
  return session.afw_1.ieo(session.gfv_1);
}
var UserProfile$mfaEnabled$slambdaClass;
function UserProfile$mfaEnabled$slambda() {
  if (UserProfile$mfaEnabled$slambdaClass === VOID) {
    class $ {
      cfz($this$withWrite, enabled, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withWrite, enabled), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.cfz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    UserProfile$mfaEnabled$slambdaClass = $;
  }
  return UserProfile$mfaEnabled$slambdaClass;
}
function UserProfile$mfaEnabled$slambda_0() {
  var i = new (UserProfile$mfaEnabled$slambda())();
  var l = ($this$withWrite, enabled, $completion) => i.cfz($this$withWrite, enabled, $completion);
  l.$arity = 2;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function UserProfile$render$lambda($this$specCenteredContent) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$specCenteredContent.pc());
  var tmp0_elvis_lhs = $this$specCenteredContent.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$specCenteredContent : tmp0_elvis_lhs;
  $this$specCenteredContent.gbb(p, view);
  view.zbm(false);
  view.lbb(get_centered(view), icon(view, resize(get_edit(Companion_getInstance()), plus(get_AppDimensions().wg1_1, get_rem(0.1))), 'Edit Profile'));
  view.lbb(get_centered(view), body(view, 'Edit Profile'));
  $this$specCenteredContent.hbb(p, view);
  return view;
}
var UserProfile$render$slambdaClass;
function UserProfile$render$slambda() {
  if (UserProfile$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.oj0_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UserProfile$render$slambdaClass = $;
  }
  return UserProfile$render$slambdaClass;
}
function UserProfile$render$slambda_0(this$0) {
  var i = new (UserProfile$render$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var UserProfile$render$lambda$slambdaClass;
function UserProfile$render$lambda$slambda() {
  if (UserProfile$render$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.tj0_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UserProfile$render$lambda$slambdaClass = $;
  }
  return UserProfile$render$lambda$slambdaClass;
}
function UserProfile$render$lambda$slambda_0(this$0) {
  var i = new (UserProfile$render$lambda$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var UserProfile$render$slambdaClass_0;
function UserProfile$render$slambda_1() {
  if (UserProfile$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.uj0_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UserProfile$render$slambdaClass_0 = $;
  }
  return UserProfile$render$slambdaClass_0;
}
function UserProfile$render$slambda_2(this$0) {
  var i = new (UserProfile$render$slambda_1())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var UserProfile$render$slambdaClass_1;
function UserProfile$render$slambda_3() {
  if (UserProfile$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.zj0_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UserProfile$render$slambdaClass_1 = $;
  }
  return UserProfile$render$slambdaClass_1;
}
function UserProfile$render$slambda_4(this$0) {
  var i = new (UserProfile$render$slambda_3())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function UserProfile$render$lambda_0($this$shownWhen) {
  return !($this$shownWhen.daj(get_currentContractor()) == null);
}
function UserProfile$render$lambda_1($this$shownWhen) {
  return $this$shownWhen.daj(get_currentContractor()) == null;
}
function UserProfile$render$lambda_2($documentType) {
  return () => new (ViewLegalDocument())($documentType);
}
var UserProfile$cooldown$slambdaClass;
function UserProfile$cooldown$slambda() {
  if (UserProfile$cooldown$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.aj1_1 = this$0;
      }
      lip($this$RestartableProcess, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, $this$RestartableProcess), $completion);
      }
      s2(p1, $completion) {
        return this.lip((!(p1 == null) ? isInterface(p1, Emitter()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    UserProfile$cooldown$slambdaClass = $;
  }
  return UserProfile$cooldown$slambdaClass;
}
function UserProfile$cooldown$slambda_0(this$0) {
  var i = new (UserProfile$cooldown$slambda())(this$0);
  var l = ($this$RestartableProcess, $completion) => i.lip($this$RestartableProcess, $completion);
  l.$arity = 1;
  return l;
}
var UserProfile$verifyPhoneNumber$slambdaClass;
function UserProfile$verifyPhoneNumber$slambda() {
  if (UserProfile$verifyPhoneNumber$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.bj1_1 = this$0;
      }
      yah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    UserProfile$verifyPhoneNumber$slambdaClass = $;
  }
  return UserProfile$verifyPhoneNumber$slambdaClass;
}
function UserProfile$verifyPhoneNumber$slambda_0(this$0) {
  var i = new (UserProfile$verifyPhoneNumber$slambda())(this$0);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var UserProfile$phoneNumberVerification$slambdaClass;
function UserProfile$phoneNumberVerification$slambda() {
  if (UserProfile$phoneNumberVerification$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.cj1_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UserProfile$phoneNumberVerification$slambdaClass = $;
  }
  return UserProfile$phoneNumberVerification$slambdaClass;
}
function UserProfile$phoneNumberVerification$slambda_0(this$0) {
  var i = new (UserProfile$phoneNumberVerification$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var UserProfile$phoneNumberVerification$slambdaClass_0;
function UserProfile$phoneNumberVerification$slambda_1() {
  if (UserProfile$phoneNumberVerification$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.dj1_1 = this$0;
        this.ej1_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    UserProfile$phoneNumberVerification$slambdaClass_0 = $;
  }
  return UserProfile$phoneNumberVerification$slambdaClass_0;
}
function UserProfile$phoneNumberVerification$slambda_2(this$0, $$this$button) {
  var i = new (UserProfile$phoneNumberVerification$slambda_1())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var UserProfileClass;
function UserProfile() {
  if (UserProfileClass === VOID) {
    class $ {
      constructor() {
        this.cj0_1 = new (Constant())(_Constant___init__impl__v45mub('Profile'));
        var tmp = this;
        tmp.dj0_1 = remember(VOID, VOID, VOID, UserProfile$cached$lambda);
        var tmp_0 = this;
        tmp_0.ej0_1 = validated(Draft(($this$Draft) => $this$Draft.eaj($this$Draft.daj(this.dj0_1))));
        this.fj0_1 = Signal().hak(false);
        this.gj0_1 = new (UserForm())(this.ej0_1, false, get_AppDimensions().gg2_1);
        var tmp_1 = this;
        var tmp_2 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.ej0_1).o88_1);
        tmp_1.hj0_1 = withWrite(tmp_2, UserProfile$mfaEnabled$slambda_0());
        this.ij0_1 = Signal().hak(null);
        this.jj0_1 = minus(toList(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90))), setOf([new (Char())(_Char___init__impl__6a9atx(73)), new (Char())(_Char___init__impl__6a9atx(79))]));
        var tmp_3 = this;
        var tmp_4 = Signal().hak('');
        tmp_3.kj0_1 = assert(tmp_4, 'Must be a valid PIN', VOID, VOID, (str) => {
          var tmp = str.length === 6;
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.text.all' call
            var inductionVariable = 0;
            while (inductionVariable < charSequenceLength(str)) {
              var element = charSequenceGet(str, inductionVariable);
              inductionVariable = inductionVariable + 1 | 0;
              if (!this.jj0_1.t1(new (Char())(element))) {
                tmp$ret$1 = false;
                break $l$block;
              }
            }
            tmp$ret$1 = true;
          }
          return !!(tmp & tmp$ret$1);
        });
        this.lj0_1 = Signal().hak(false);
        var tmp_5 = this;
        tmp_5.mj0_1 = RestartableProcess().yg5(VOID, UserProfile$cooldown$slambda_0(this));
        var tmp_6 = this;
        tmp_6.nj0_1 = Action('Verify Phone Number', VOID, UserProfile$verifyPhoneNumber$slambda_0(this));
      }
      wcv() {
        return this.cj0_1;
      }
      wd6(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        var tmp_0 = view.kbb(align(view, Align_Start_getInstance(), Align_Stretch_getInstance()), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        view_0.bb9(get_AppDimensions().ag2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(false);
        var tmp_1 = view_1.kbb(get_centered(view_1), get_expanding(view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(true);
        view_2.bb9(get_AppDimensions().pg2_1);
        title(view_2, 'Profile');
        var tmp_2 = shownWhen(view_2, VOID, ($this$shownWhen) => !($this$shownWhen.daj(this.ej0_1).k88_1 == null));
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (TextView())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.lba(view_3.qb6_1.abf(SubtitleSemantic_getInstance()));
        var tmp_3 = KMutableProperty0();
        var tmp_4 = TextView$_get_content_$ref_4pzcwl(view_3);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(view_3));
        reactiveScope(view_3, ($this$reactiveScope) => {
          var tmp0_safe_receiver = $this$reactiveScope.daj(this.ej0_1).k88_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8c_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.a4_1;
          var tmp$ret$0 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
          this_0.set(tmp$ret$0);
          return Unit_instance;
        });
        view_2.hbb(p_3, view_3);
        view_2.lbb(tmp_2, view_3);
        view_1.hbb(p_2, view_2);
        view_1.lbb(tmp_1, view_2);
        var tmp_5 = get_centered(view_1);
        var tmp_6 = view_1.kbb(view_1.kbb(tmp_5, shownWhen(view_1, VOID, ($this$shownWhen) => !$this$shownWhen.daj(this.fj0_1))), get_tertiaryButton(view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Button())(view_1.pc());
        var tmp0_elvis_lhs_4 = view_1.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
        view_1.gbb(p_4, view_4);
        specCenteredContent(view_4, VOID, UserProfile$render$lambda);
        onClick(view_4, VOID, VOID, UserProfile$render$slambda_0(this));
        view_1.hbb(p_4, view_4);
        view_1.lbb(tmp_6, view_4);
        view_0.hbb(p_1, view_1);
        // Inline function 'com.crowpay.views.components.sectionIndentCol' call
        // Inline function 'com.crowpay.views.components.indentedCol' call
        var indent = Indent_Section_getInstance();
        var tmp2 = indent.agr_1;
        // Inline function 'com.crowpay.views.components.indentedCol' call
        var afterSpace = indent.bgr_1;
        var tmp_7 = get_unpadded(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Frame())(view_0.pc());
        var tmp0_elvis_lhs_5 = view_0.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_0 : tmp0_elvis_lhs_5;
        view_0.gbb(p_5, view_5);
        var tmp_8;
        var tmp_9 = null;
        if (!((tmp_9 == null ? null : new (Dimension())(tmp_9)) == null)) {
          tmp_8 = sizeConstraints(view_5, VOID, VOID, VOID, VOID, VOID, null);
        } else {
          tmp_8 = Companion_getInstance_0();
        }
        var tmp_10 = view_5.kbb(tmp_8, indented(view_5, tmp2, afterSpace));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.gbb(p_6, view_6);
        view_6.zbm(true);
        var tmp_11 = shownWhen(view_6, VOID, ($this$shownWhen) => !$this$shownWhen.daj(this.fj0_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (RowOrCol())(view_6.pc());
        var tmp0_elvis_lhs_7 = view_6.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
        view_6.gbb(p_7, view_7);
        view_7.zbm(true);
        label2(view_7, 'Legal Name', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          view.lba(view.qb6_1.abf(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_0(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_0(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$18 = get_fullName($this$reactiveScope.daj(this.ej0_1));
            this_0.set(tmp$ret$18);
            return Unit_instance;
          });
          $this$label2.hbb(p, view);
          return view;
        });
        label2(view_7, 'Email', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          view.lba(view.qb6_1.abf(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_1(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_1(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$25 = _EmailAddress___get_raw__impl__6ose2($this$reactiveScope.daj(this.ej0_1).e88_1);
            this_0.set(tmp$ret$25);
            return Unit_instance;
          });
          $this$label2.hbb(p, view);
          return view;
        });
        label2(view_7, 'Phone Number', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          view.lba(view.qb6_1.abf(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_2(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_2(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp = PhoneNumberFormat_USA_getInstance();
            // Inline function 'kotlin.text.filter' call
            var tmp0 = _PhoneNumber___get_raw__impl__gc2pmp($this$reactiveScope.daj(this.ej0_1).f88_1);
            // Inline function 'kotlin.text.filterTo' call
            var destination = StringBuilder().d1();
            var inductionVariable = 0;
            var last = charSequenceLength(tmp0);
            if (inductionVariable < last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var element = charSequenceGet(tmp0, index);
                if (isDigit(element)) {
                  destination.xb(element);
                }
              }
               while (inductionVariable < last);
            var tmp$ret$34 = destination.toString();
            var tmp$ret$35 = tmp.adb(takeLast(tmp$ret$34, 10));
            this_0.set(tmp$ret$35);
            return Unit_instance;
          });
          $this$label2.hbb(p, view);
          return view;
        });
        view_7.lbb(view_7.kbb(shownWhen(view_7, VOID, ($this$shownWhen) => !$this$shownWhen.daj(this.fj0_1) && !$this$shownWhen.daj(this.ej0_1).p88_1), get_lightSection(view_7)), phoneNumberVerification(this, view_7));
        var tmp_12 = shownWhen(view_7, VOID, ($this$shownWhen) => isNotBlank($this$shownWhen.daj(this.ej0_1).j88_1));
        view_7.lbb(tmp_12, label2(view_7, 'Address', VOID, ($this$label2) => {
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          view.lba(view.qb6_1.abf(BodySemantic_getInstance()));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_3(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_3(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$42 = $this$reactiveScope.daj(this.ej0_1).j88_1.toString();
            this_0.set(tmp$ret$42);
            return Unit_instance;
          });
          $this$label2.hbb(p, view);
          return view;
        }));
        label2(view_7, 'MFA (Multi Factor Authentication)', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          view.zbm(false);
          var tmp = get_expanding(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zbm(true);
          view_0.bb9(get_dp(0));
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (TextView())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.gbb(p_1, view_1);
          view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value = 'Enable SMS One Time Passwords for Login';
          var tmp_0 = view_1.vb5_1;
          var tmp_1;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value) === 0) {
            tmp_1 = '\xA0';
          } else {
            tmp_1 = value;
          }
          tmp_0.hbu(tmp_1);
          view_0.hbb(p_1, view_1);
          var tmp_2 = shownWhen(view_0, VOID, ($this$shownWhen) => !$this$shownWhen.daj(this.ej0_1).p88_1);
          // Inline function 'com.crowpay.views.theming.smallBody' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (TextView())(view_0.pc());
          var tmp0_elvis_lhs_2 = view_0.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
          view_0.gbb(p_2, view_2);
          view_2.lba(view_2.qb6_1.abf(SmallBodySemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value_0 = '(Requires your phone number to be verified)';
          var tmp_3 = view_2.vb5_1;
          var tmp_4;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value_0) === 0) {
            tmp_4 = '\xA0';
          } else {
            tmp_4 = value_0;
          }
          tmp_3.hbu(tmp_4);
          view_0.hbb(p_2, view_2);
          view_0.lbb(tmp_2, view_2);
          view.hbb(p_0, view_0);
          view.lbb(tmp, view_0);
          var tmp_5 = get_centered(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (Frame())(view.pc());
          var tmp0_elvis_lhs_3 = view.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
          view.gbb(p_3, view_3);
          // Inline function 'com.lightningkite.kiteui.views.direct.switch' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (Switch())(view_3.pc());
          var tmp0_elvis_lhs_4 = view_3.ebb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
          view_3.gbb(p_4, view_4);
          // Inline function 'com.lightningkite.kiteui.views.direct.Switch.enabled' call
          var tmp0 = view_4.vb5_1.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.disabled' call
          var value_1 = !false;
          tmp0.kb7_1.disabled = value_1;
          view_4.zah(view_4.eck_1, this.hj0_1);
          view_3.hbb(p_4, view_4);
          var tmp_6 = view_3.jbb(NoHoverSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (Button())(view_3.pc());
          var tmp0_elvis_lhs_5 = view_3.ebb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
          view_3.gbb(p_5, view_5);
          var tmp_7 = KMutableProperty0();
          var tmp_8 = Button$_get_enabled_$ref_61t7nx(view_5);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('enabled', 0, tmp_7, tmp_8, Button$_set_enabled_$ref_o8kynz(view_5));
          reactiveScope(view_5, ($this$reactiveScope) => {
            var tmp$ret$72 = $this$reactiveScope.daj(this.ej0_1).p88_1;
            this_0.set(tmp$ret$72);
            return Unit_instance;
          });
          onClick(view_5, VOID, VOID, UserProfile$render$lambda$slambda_0(this));
          view_3.hbb(p_5, view_5);
          view_3.lbb(tmp_6, view_5);
          view.hbb(p_3, view_3);
          view.lbb(tmp_5, view_3);
          $this$label2.hbb(p, view);
          return view;
        });
        view_6.hbb(p_7, view_7);
        view_6.lbb(tmp_11, view_7);
        var tmp_13 = shownWhen(view_6, VOID, ($this$shownWhen) => $this$shownWhen.daj(this.fj0_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_6.pc());
        var tmp0_elvis_lhs_8 = view_6.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
        view_6.gbb(p_8, view_8);
        view_8.zbm(true);
        render(this.gj0_1, view_8);
        var tmp_14 = align(view_8, Align_End_getInstance(), Align_End_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (RowOrCol())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.ebb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.gbb(p_9, view_9);
        view_9.zbm(false);
        view_9.bb9(get_AppDimensions().kg2_1);
        var tmp_15 = get_secondaryButton(view_9);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (Button())(view_9.pc());
        var tmp0_elvis_lhs_10 = view_9.ebb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
        view_9.gbb(p_10, view_10);
        specCenteredText_0(view_10, 'Cancel');
        onClick(view_10, VOID, VOID, UserProfile$render$slambda_2(this));
        view_9.hbb(p_10, view_10);
        view_9.lbb(tmp_15, view_10);
        var tmp_16 = get_primaryButton(view_9);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (Button())(view_9.pc());
        var tmp0_elvis_lhs_11 = view_9.ebb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_9 : tmp0_elvis_lhs_11;
        view_9.gbb(p_11, view_11);
        var tmp_17 = KMutableProperty0();
        var tmp_18 = Button$_get_enabled_$ref_61t7nx_0(view_11);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('enabled', 0, tmp_17, tmp_18, Button$_set_enabled_$ref_o8kynz_0(view_11));
        reactiveScope(view_11, ($this$reactiveScope) => {
          var tmp$ret$91 = $this$reactiveScope.daj(get_issues(this.ej0_1)).i1();
          this_1.set(tmp$ret$91);
          return Unit_instance;
        });
        specCenteredText_0(view_11, 'Save');
        onClick(view_11, VOID, VOID, UserProfile$render$slambda_4(this));
        view_9.hbb(p_11, view_11);
        view_9.lbb(tmp_16, view_11);
        view_8.hbb(p_9, view_9);
        view_8.lbb(tmp_14, view_9);
        view_6.hbb(p_8, view_8);
        view_6.lbb(tmp_13, view_8);
        view_5.hbb(p_6, view_6);
        view_5.lbb(tmp_10, view_6);
        view_0.hbb(p_5, view_5);
        view_0.lbb(tmp_7, view_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (Space())(view_0.pc());
        var tmp0_elvis_lhs_12 = view_0.ebb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_0 : tmp0_elvis_lhs_12;
        view_0.gbb(p_12, view_12);
        view_0.hbb(p_12, view_12);
        title(view_0, 'Terms and Conditions');
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_13 = view_0.ebb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_0 : tmp0_elvis_lhs_13;
        view_0.gbb(p_13, view_13);
        view_13.zbm(true);
        var _iterator__ex2g4s = get_entries().m1();
        while (_iterator__ex2g4s.n1()) {
          var documentType = _iterator__ex2g4s.o1();
          var tmp_19;
          switch (documentType.g91_1.b4_1) {
            case 0:
              tmp_19 = shownWhen(view_13, VOID, UserProfile$render$lambda_0);
              break;
            case 1:
              tmp_19 = shownWhen(view_13, VOID, UserProfile$render$lambda_1);
              break;
            case 2:
              tmp_19 = Companion_getInstance_0();
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          var tmp_20 = view_13.kbb(tmp_19, get_compact(view_13));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_14 = new (RowOrCol())(view_13.pc());
          var tmp0_elvis_lhs_14 = view_13.ebb_1;
          var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
          view_13.gbb(p_14, view_14);
          view_14.zbm(false);
          var tmp_21 = view_14.kbb(get_centered(view_14), get_textButton(view_14));
          // Inline function 'com.lightningkite.kiteui.views.direct.link' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_15 = new (Link())(view_14.pc());
          var tmp0_elvis_lhs_15 = view_14.ebb_1;
          var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
          view_14.gbb(p_15, view_15);
          // Inline function 'com.crowpay.views.theming.subTitle' call
          var content = '\u2022 ' + documentType.f91_1;
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_16 = new (TextView())(view_15.pc());
          var tmp0_elvis_lhs_16 = view_15.ebb_1;
          var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
          view_15.gbb(p_16, view_16);
          view_16.lba(view_16.qb6_1.abf(SubtitleSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var tmp_22 = view_16.vb5_1;
          var tmp_23;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(content) === 0) {
            tmp_23 = '\xA0';
          } else {
            tmp_23 = content;
          }
          tmp_22.hbu(tmp_23);
          view_15.hbb(p_16, view_16);
          view_15.kbw(UserProfile$render$lambda_2(documentType));
          view_14.hbb(p_15, view_15);
          view_14.lbb(tmp_21, view_15);
          view_14.lbb(get_centered(view_14), exportCrowPayLegalDocument(view_14, get_waitForNotNull((new (AgreementData())(documentType)).xfy_1), times(get_AppDimensions().vg1_1, 1.1)));
          view_13.hbb(p_14, view_14);
          view_13.lbb(tmp_20, view_14);
        }
        view_0.hbb(p_13, view_13);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_17 = new (Space())(view_0.pc(), 5.0);
        var tmp0_elvis_lhs_17 = view_0.ebb_1;
        var p_17 = tmp0_elvis_lhs_17 == null ? view_0 : tmp0_elvis_lhs_17;
        view_0.gbb(p_17, view_17);
        view_0.hbb(p_17, view_17);
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
    }
    initMetadataForClass($, 'UserProfile', UserProfile, VOID, [Page()]);
    UserProfileClass = $;
  }
  return UserProfileClass;
}
//region block: exports
export {
  UserProfile as UserProfile2tyxfth4oycef,
};
//endregion

//# sourceMappingURL=UserProfile.mjs.map
